import React from 'react';
import { Chip, Typography } from '@mui/material';
import { isBankPayment } from './orderStatus';
import { formatPaymentType } from './orderUtils';

const PAYMENT_TONES = {
  bank: {
    backgroundColor: '#fff0df',
    borderColor: '#d97706',
    color: '#9a4d00'
  },
  delivery: {
    backgroundColor: '#fff9d9',
    borderColor: '#c99700',
    color: '#735600'
  }
};

export default function OrderPaymentChip({ paymentType, bankPayment = false }) {
  if (!paymentType) {
    return <Typography variant="body2">—</Typography>;
  }

  const tone = bankPayment || isBankPayment(paymentType) ? PAYMENT_TONES.bank : PAYMENT_TONES.delivery;
  const label = formatPaymentType(paymentType);

  return (
    <Chip
      aria-label={`Предпочитано плащане: ${label}`}
      label={label}
      size="small"
      variant="outlined"
      sx={{
        backgroundColor: tone.backgroundColor,
        borderColor: tone.borderColor,
        color: tone.color,
        fontWeight: 700
      }}
    />
  );
}
